import Price from './price';

function Bnovo(parent, search) {
    Price.call(this, parent, search);
}

Bnovo.prototype = Object.create(Price.prototype);
Object.defineProperty(Bnovo.prototype, 'constructor', {
    value: Bnovo,
    enumerable: false,
    writable: true,
});

export default Bnovo;
